// Busca do cardápio. Ignora maiúsculas e acentos: "acai" acha "Açaí" e
// "pure" acha "Purê" — quem digita no celular raramente acentua.
export function normalizeSearchText(text) {
  return (text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function productMatchesSearch(product, query) {
  const needle = normalizeSearchText(query);
  if (!needle) {
    return true;
  }

  return (
    normalizeSearchText(product.name).includes(needle) ||
    normalizeSearchText(product.details).includes(needle)
  );
}

export default function filterProductsBySearch(products, query) {
  return products.filter((p) => productMatchesSearch(p, query));
}
